export { default } from './extended-warranty';